<template>
  <div class="page-content">
    <el-breadcrumb  separator="/">
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      <el-breadcrumb-item><span style="cursor: pointer;" @click="onChangePage">资料信息</span></el-breadcrumb-item>
      <el-breadcrumb-item v-if="isBindMobile">修改绑定</el-breadcrumb-item>
      <el-breadcrumb-item v-if="isUpdatePassword">修改密码</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row v-if="!isBindMobile && !isUpdatePassword" :gutter="20" class='row_more'>
      <el-col :span="7">
        <!-- flex-direction:column; -->
        <div style="height:650px;display: block;border-radius:16px;" class="g-content-box g-vertical-center">
          <div style="width: 100%;text-align: center;">
            <el-image style="width: 100px;margin-top: 64px;" :src="smallLogo"></el-image>
          </div>
          <span class="g-block" style="font-size: 20px;font-weight:bold;padding: 40px 0 60px;text-align: center;">{{ dealerInfo.dealername }}</span>
          <div class="myinfo-detail-item" style="padding-top: 20px;">
          <el-row style="border-bottom: 1px solid #EBEEF5;padding-bottom: 8px;">
            <el-col :span="24">
              <i class="el-icon-user myinfo-icon"></i>
              <span class="g-margin-left" style="font-weight: bold;">
                用户名：
              </span>
            </el-col>
            <el-col :span="18" style="padding-top: 8px;">
              <span style="margin-left: 30px;">
                {{ userInfo.username }}
              </span>
            </el-col>
            <el-col :span="6" style="padding-top: 8px;text-align: right;">
              <span @click="onUpdatePassword" class="myinfo-btn">
                修改密码
              </span>
            </el-col>
          </el-row>
        </div>

        <div class="myinfo-detail-item" style="padding-top: 8px;">
          <el-row style="border-bottom: 1px solid #EBEEF5;padding-bottom: 8px;">
            <el-col :span="24">
              <img class="myinfo-icon myinfo-img" :src="phone" alt="">
              <span class="g-margin-left" style="font-weight: bold;">
                绑定手机：
              </span>
            </el-col>
            <el-col :span="18" style="padding-top: 8px;">
              <span style="margin-left: 30px;">
                {{ userInfo.mobile ? userInfo.mobile : "-" }}
              </span>
            </el-col>
            <el-col :span="6" style="padding-top: 8px;text-align: right;">
              <span @click="onBindMobile" class="myinfo-btn">
                {{ hasMobile ? '修改绑定' : '立即绑定' }}
              </span>
            </el-col>
            <el-col :span="24" style="padding-top: 8px;padding-left: 27px;">
              <span class="myinfo-btn" style="color: #00000072;">
                用于找回密码验证身份
              </span>
            </el-col>
          </el-row>
        </div>

        <div class="myinfo-detail-item" style="padding-top: 8px" v-if="userInfo.usertype != 'KEFU'">
          <el-row style="border-bottom: 1px solid #ebeef5; padding-bottom: 8px">
            <el-col :span="24">
              <img class="myinfo-icon myinfo-img" :src="email" alt="" />
              <span class="g-margin-left" style="font-weight: bold">
                绑定邮箱：
              </span>
            </el-col>
            <el-col :span="18" style="padding-top: 8px">
              <span style="margin-left: 30px">
                {{ userInfo.email ? userInfo.email : "-" }}
              </span>
            </el-col>
            <el-col :span="6" style="padding-top: 8px; text-align: right">
              <span @click="onBindemail(userInfo.email)" class="myinfo-btn">
                {{ userInfo.email ? "修改绑定" : "立即绑定" }}
              </span>
            </el-col>
            <el-col :span="24" style="padding-top: 8px; padding-left: 27px">
              <span class="myinfo-btn" style="color: #00000072">
                绑定邮箱后可便捷接收消息提醒和通知公告信息
              </span>
            </el-col>
          </el-row>
        </div>

        <div class="myinfo-detail-item" style="padding-top: 8px;clear: both;">
          <el-row>
            <el-col :span="13">
              <img class="myinfo-icon myinfo-img" :src="wechat" alt="">
              <span class="g-margin-left" style="font-weight: bold;">
                绑定微信: &nbsp;
              </span>
            </el-col>
            <el-col :span="11">
               <span class="myinfo-btn" @click="onBindWechat(userInfo.openid)">
                立即绑定
              </span>
            </el-col>
            <div style="height: 140px;overflow-y: auto;width: 100%;">
              <el-row v-for="(item,index) in wechatBindList" :key="item.id" v-if="item.openid" style="clear: both;">
                <el-col :span="15"style="padding-left: 30px;margin-top: 8px;">{{item.nickname}}</el-col>
                <el-col :span="9" style="text-align: right;margin-top: 8px;" class="myinfo-btn">
                  <el-popover
                    placement="bottom"
                    width="240"
                    v-model="visibleShow[index]">
                    <div style="display: flex;width: 100%;justify-content:center;">
                      <i class="el-icon-warning" style="color:#faad14;font-size: 24px;"></i>
                      <div>
                        <div style="font-size: 16px;">
                          你确认要解绑微信绑定吗？
                        </div>
                        <div style="font-size: 14px;">解绑后
                          <span style="color: #e90e24;font-size: 14px;">
                            将失去消息推送和扫码登录功能
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style="text-align: right;">
                      <el-button type="primary" @click="onBindWechatOrUnbind(item.openid,index)" size="mini">确 定</el-button>
                      <el-button @click="qxWx(index)" size="mini" type="TheCustom">取 消</el-button>
                    </div>
                    <div slot="reference" style="cursor: pointer;">解除绑定</div>
                  </el-popover>

                </el-col>
              </el-row>
            </div>

            <el-col :span="24" style="margin-top: 8px;padding: 0 0 8px 30px;color: #00000072;">
              <span>绑定微信可便捷接收消息提醒和微信扫码登录</span>
            </el-col>
          </el-row>
        </div>
        </div>
      </el-col>
      <el-col :span="17" id="newDealCard">
        <el-card class="g-content-box shopinfo-card">
          <div style="font-size: 16px;font-weight: 700;color: #000000D8;margin-bottom: 24px;">
            基本信息
          </div>
          <el-form label-width="120px">
            <el-form-item v-for="(item, index) in customFields" :key="index" :label="item.label + ':'" >
              <span v-if="item.label !== '经销商层级'">
                {{item.value}}
              </span>
              <span v-else>
                {{ item.value }}
              </span>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="onEditCompany">编辑</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
      <!--资料信息编辑页 -->
      <el-dialog
        title="编辑"
        :visible.sync="showEditDialog"
        width="500px"
      >
        <el-form ref="company" :rules="companyRules" :model="form" label-width="100px">
        <el-form-item label="经销商名称">
          <el-input disabled v-model="form.dealername"></el-input>
        </el-form-item>
        <el-form-item label="对接人" prop="takepeople">
          <el-input v-model="form.takepeople"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-enter-number v-model="form.contact"></el-input>
        </el-form-item>
        <el-form-item label="所在地区" prop="area">
          <VDistpicker
            :province="form.province"
            :city="form.city"
            :area="form.strict"
            @province="onChangeProvince"
            @city="onChangeCity"
            @area="onChangeArea"
          ></VDistpicker>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.address">
          </el-input>
        </el-form-item>
      </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" class="g-confirm-btn" @click="onSubmitCompany">确定</el-button>
          <el-button size="small" class="g-cancel-btn" @click="showEditDialog = false">取消</el-button>
        </span>
      </el-dialog>
      <!--微信绑定页 -->
      <el-dialog :visible.sync="showWechatDialog" width="360px" id="newDataInformation">
        <div style="text-align: center;">
          <img :src="wechatUrl" style="width: 197px;height: 197px;" />
          <div style="font-size: 18px;color: #333333;margin-top: -13px;">关注微信公众号，绑定微信</div>
          <div style="font-size: 14px;color: #999999;margin-top: 41px;">关注微信公众号，绑定微信后:</div>
          <div style="font-size: 14px;color: #999999;margin-top: 12px;">1、可在移动端中查看业务消息，处理业务事项。</div>
          <div
            style="font-size: 14px;color: #999999;text-align: center;"
          >2、登录时可以使用微信扫码登录。</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="confire_btn" @click="showWechatDialog = false" size="small">我知道了</el-button>
        </span>
      </el-dialog>
      <!-- <el-dialog
        title="微信绑定"
        :visible.sync="showWechatDialog"
        width="15%"
      >
        <el-image
          style="width: 100%; height: 100%"
          :src="wechatUrl"
        >
        </el-image>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" class="g-confirm-btn" @click="showWechatDialog = false">确定</el-button>
          <el-button size="small" class="g-cancel-btn"  @click="showWechatDialog = false">取消</el-button>
        </span>
      </el-dialog> -->
    <!--绑定手机页 -->
    <div v-if="isBindMobile">
      <div class="g-content-box" v-if="hasMobile">
        <el-steps :active="currentMobileStep">
          <el-step title="验证身份" description="需要使用当前绑定手机验证身份"></el-step>
          <el-step title="绑定新手机" description="请填写你需要绑定的新手机号"></el-step>
          <el-step title="绑定成功" description="成功绑定新手机号码"></el-step>
        </el-steps>
      </div>
      <div v-if="hasMobile && currentMobileStep === 0" class="myinfo-mobile-box">
        <el-form :model="mobile" ref="mobile" label-width="80px" class="myinfo-mobile-form">
          <el-form-item label="手机号">
            <span>{{ userInfo.mobile }}</span>
          </el-form-item>
          <el-form-item class="myinfo-code-item" label="验证码">
            <el-input v-model="mobile.code" class="myinfo-code-input" placeholder="输入验证码"></el-input>
            <el-button size="small" :disabled="Boolean(codeNumber)" class="g-margin-left" @click="getMobileCode(1)">
              <span v-if="!codeNumber">获取验证码</span>
              <span v-else>{{ codeNumber }}s后重新发送</span>
            </el-button>

            <p v-if="codeNumber">
              <i class="el-icon-success" style="color: #3FB838"></i>
              <span class="g-margin-left">
                验证码已发送到你的手机，5分钟内输入有效
              </span>
              <span class="g-block" style="padding-left: 24px">
                验证码等同于密码，打死也不能告诉别人!
              </span>
            </p>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="g-confirm-btn" @click="onConfirmCode(1)">确定</el-button>
            <el-button size="small" class="g-cancel-btn" @click="isBindMobile = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="(hasMobile && currentMobileStep === 1) || (!hasMobile && currentMobileStep === 0)" class="myinfo-mobile-box">
        <el-form :model="newmobile" ref="newmobile" label-width="80px" class="myinfo-mobile-form">
          <el-form-item label="新手机号">
            <el-input v-enter-number v-model="newmobile.mobile" class="myinfo-code-input" placeholder="输入新手机号"></el-input>
          </el-form-item>
          <el-form-item class="myinfo-code-item" label="验证码">
            <el-input v-model="newmobile.code" class="myinfo-code-input" placeholder="输入验证码"></el-input>
            <el-button size="small" :disabled="Boolean(codeNumber)" class="g-margin-left" @click="getMobileCode(2)">
              <span v-if="!codeNumber">获取验证码</span>
              <span v-else>{{ codeNumber }}s后重新发送</span>
            </el-button>

            <p v-if="codeNumber">
              <i class="el-icon-success" style="color: #3FB838"></i>
              <span class="g-margin-left">
                验证码已发送到你的手机，5分钟内输入有效
              </span>
              <span class="g-block" style="padding-left: 24px">
                验证码等同于密码，打死也不能告诉别人!
              </span>
            </p>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="g-confirm-btn" @click="onConfirmCode(2)">提交</el-button>
            <el-button size="small" class="g-cancel-btn" @click="isBindMobile = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="currentMobileStep === 2" class="myinfo-mobile-box myinfo-bind-success">
        <i class="el-icon-success" style="color: #3FB838;font-size: 40px;display: block"></i>
        <p>绑定成功</p>
        <p>新登录方式:使用新手机号和密码登录</p>
        <el-button size="small" class="g-confirm-btn" @click="isBindMobile = false;load()">完成</el-button>
      </div>
      </div>
       <!-- 修改密码页 -->
      <div v-if="isUpdatePassword">
      <div class="myinfo-mobile-box">
        <el-form :model="password" :rules="passwordRules" ref="password" label-width="100px" class="myinfo-mobile-form">
          <el-form-item label="当前密码" prop="current">
            <el-input type="password" v-model="password.current" placeholder="输入当前密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new">
            <el-popover
              placement="right"
              trigger="focus"
              width="150"
              >
              <div >
                <span>
                  强度: &nbsp; {{ passwordPercent === 33 ? '弱' : passwordPercent === 100 ? '强' : '中'  }}
                </span>
                <el-progress
                  :show-text="false"
                  :percentage="passwordPercent"
                  :color="customColors">
                </el-progress>
                <span class="g-block">
                  请至少输入6个字符，请不要使用容易被猜到的密码
                </span>
              </div>
              <div slot="reference">
                <el-input @input="onPasswordChange" type="password" v-model="password.new" placeholder="输入新密码"></el-input>
              </div>
            </el-popover>
          </el-form-item>
          <el-form-item label="确认新密码" prop="checknew">
            <el-input type="password" v-model="password.checknew" placeholder="再次输入新密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="g-confirm-btn" @click="onSubmitPassword">确定</el-button>
            <el-button size="small" class="g-cancel-btn" @click="isUpdatePassword = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <dearEditor ref="childDearEditor"></dearEditor>
    <el-dialog title="编辑" :visible.sync="theEditorShow" width="20%" style="margin-top: 10%;">
      <el-form>
        <el-form-item label="邮箱" label-width="60px">
          <el-input v-model="exEmail" placeholder="请输入邮箱" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()" size="small">确 定</el-button>
        <el-button @click="theEditorShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import VDistpicker from 'v-distpicker';
import Wechat from '@/assets/img/other/wechat.png'
import Calendar from '@/assets/img/other/calendar.png'
import Phone from '@/assets/img/other/phone.png'
import smallLogo from '@/assets/img/smallLogo.png'
import dearEditor from './dearEditor'
import email from '@/assets/img/other/email.png'
import aes from '@/libs/aes'
import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";
export default {
  name: 'DataInfomation',

  components:{
    VDistpicker,dearEditor,wxBindingComponent
  },

  data () {

    let validatePass = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入新密码'));
			} else if (value.toString().length < 6 || value.toString().length > 16) {
				callback(new Error('密码长度为6 - 16个字符'))
			} else {
				callback();
			}
    };
		let validatePass2 = (rule, value, callback) => {
	    if (value === '') {
	      callback(new Error('请再次输入密码'));
	    } else if (value !== this.password.new) {
	      callback(new Error('两次输入密码不一致!'));
	    } else {
	      callback();
	    }
	  };
    return {
      visibleShow: [],
      smallLogo: smallLogo,
      wechatUrl: "",
      customFields: {},
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      passwordPercent: 33,
      customColors: [
        {color: '#f56c6c', percentage: 34},
        {color: '#e6a23c', percentage: 67},
        {color: '#5cb87a', percentage: 99},
      ],
      passwordStatus: 'low',
      password: {},
      companyRules: {
        address: [
            { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        takepeople: [
            { required: true, message: '请输入对接人', trigger: 'blur' }
        ],
        contact: [
            { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
      },
      passwordRules: {
        new: [
            { required: true, validator: validatePass, trigger: 'blur' }
        ],
        checknew: [
            { required: true, validator: validatePass2, trigger: 'blur' }
        ],
        current: [
            { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
      },
      showWechatDialog: false,
      isUpdatePassword: false,
      timer: null,
      newmobile: {},
      currentMobileStep: 0,
      codeNumber: 0,
      mobile: {},
      selectArea:{
        province:'',city:'',area:''
      },
      form: {},
      showEditDialog: false,
      wechat: Wechat,
      calendar: Calendar,
      phone: Phone,
      isBindMobile: false,
      activeName:'first',
      newUserid: '',
      theEditorShow: false,
      exEmail: '',
      email: email,
    }
  },
  created(){
  },
  methods: {
    onBindemail(email) {
      this.theEditorShow = true
      if (email) {
        this.exEmail = email
      } else {
        this.exEmail = ''
      }
    },
    isEmail (s) {
      return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
    },
    submitForm() {
      if (!this.isEmail(this.exEmail)) {
        this.$message({
          message: '请输入正确的邮箱格式',
          type: 'warning'
        });
        return
      }
      let params = {
        email: this.exEmail,
      }
      fetch({
        url: "hcm/user/setEmail",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
        }
        this.theEditorShow = false
        this.load();
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    handleTabsClick(){
      //tab切换
    },
    getDealerLevel(level) {
      switch (level) {
        case '0':
          return ""
          break;
        case '1':
          return "一级经销商"
          break;
        case '2':
          return "二级经销商"
          break;
        case '3':
          return "三级经销商"
          break;
      }

    },
    // 地区选区取值(省)
    onChangeProvince(a){
      this.form.province = a.value;
    },
    onChangeCity(a){ //(市)
      this.form.city = a.value;
    },
    onChangeArea(a){  //(区)
      this.form.strict = a.value;
    },
    onSubmitCompany() {
      console.log(this.form);

      this.$refs['company'].validate((valid) => {
        if(valid) {
          let data = {
            contact: this.form.contact,
            province: this.form.province,
            city: this.form.city,
            strict: this.form.strict,
            address: this.form.address,
            take_people: this.form.takepeople,
          }

          this.reqEditDealer(data).then(res => {
            if(res.status === '10000') {
              this.reqDealerInfo();
              this.showEditDialog = false;
            }
          })
        }

      })
		},
		onBindWechat(openid) {
      this.$refs.childWxBinding.getbmcwx('c',this.userInfo.id,openid)
		},
    qxWx(index) {
      this.$set(this.visibleShow,index,false)
    },
    onBindWechatOrUnbind(openid,index) {
      let data = {
        openid: openid,
        usertype: 'c',
        domainname: window.location.host.substring(0, window.location.host.indexOf(".")),
        userid:this.userInfo.id
      }
      if(openid) {
        //解除绑定
        this.reqUnbindWx(data).then((res) => {
          if(res.status === '10000') {
            this.$set(this.visibleShow,index,false)
            this.load();
            this.getWecharList();
            this.$message.success('解绑成功');
          }
        })
      }else {
        this.$refs.childWxBinding.getbmcwx('c',this.userInfo.bid,openid)
      }

    },
    onEditCompany() {
      let data = {
        id:this.dealerInfo.id,
      }
      this.$refs.childDearEditor.startEditor(data)
      // this.$router.push({path:'/dealersDataInformationsEdit',query:{id:this.dealerInfo.id}})
      // this.form = {};
      // this.form = Object.assign({}, this.form, this.dealerInfo);
    },
    ...mapActions([
      'reqMoblieCode',
      'reqMyInfomation',
      'reqBindMobile',
      'reqUpdatePassword',
      'reqEditDealer',
      'reqUnbindWx',
      'reqDealerInfo',
      'reqUser',
      'reqCustomField',
      'reqValidateSMS',
      'getWecharList',
    ]),
    onUpdatePassword() {
      this.passwordPercent = 33;
      this.isUpdatePassword = true;
    },
    onSubmitPassword() {
      this.$refs['password'].validate((valid) => {
        if (valid) {
          let data = {
            password: aes.encrypt(this.password.new, 'hcmabcdefghijklm'),
            oldPassword: aes.encrypt(this.password.current, 'hcmabcdefghijklm'),
            username: this.dealerInfo.username
          }
          this.reqUpdatePassword(data).then((res) => {
            if(res.status === '10000') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            }
            if(res.status === '400') {
              this.$message({
                message: `${res.message}`,
                type: 'error'
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onPasswordChange(value) {
      let numberReg = /^[0-9]*$/;
      let bigReg = /^[A-Z]+$/;
      let smallReg = /^[a-z]+$/;
      let specialReg = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/;
      let number = false;
      let small = false;
      let big = false;
      let special = false;
      let strArr = value.split("");
      if(strArr.length < 6) {
        this.passwordPercent = 33;
      }else if(6 < strArr.length < 16){
        for(let i of strArr) {
          if(numberReg.test(i)) {
            number = true;
          }
          if(bigReg.test(i)) {
            big = true;
          }
          if(smallReg.test(i)) {
            small = true;
          }
          if(specialReg.test(i)) {
            special = true;
          }

        }
        let res = [
          number, small, big, special
        ]
        let trueRes = res.filter(item => {
          return item === true;
        })
        if(trueRes.length === 1) {
          this.passwordPercent = 33;
        }else if(2 === trueRes.length || trueRes.length === 3) {
          this.passwordPercent = 66;
        }else if(trueRes.length === 4) {
          this.passwordPercent = 100;
        }
      }
    },
    getMobileCode(step) {
      let data;
      if(step === 1) {
        data = {
          mobile: this.userInfo.mobile,
          codeType: 'HCM_UPM',
          usertype: localStorage.getItem('usertype')
        }
      }else {
        data = {
          mobile: this.newmobile.mobile,
          codeType: 'HCM_BIND',
          usertype: localStorage.getItem('usertype')
        }
      }


      this.reqMoblieCode(data).then((res) => {
        if(res.status === '400' || res.status === '410') {
          this.$message.error(res.message);
          return ;
        }
        this.codeNumber = 60;
        this.handleTimer();
      })

    },
    handleTimer() {
      this.timer = setTimeout(() => {
          this.codeNumber--;
          if(!this.codeNumber) {
            clearTimeout(this.timer);
            return
          }
          this.handleTimer();
        }, 1000);
    },
    reinitTimer() {
      this.codeNumber = 0;
      clearTimeout(this.timer);
    },
    onConfirmCode(step) {
      this.reinitTimer();
      if(step === 2) {
        let data = {
          mobile: this.newmobile.mobile,
          code: this.newmobile.code
        }
        this.reqValidateSMS(data).then((res) => {
          if(res) {
            this.reqBindMobile({
              mobile: this.newmobile.mobile
            }).then(() => {
              this.currentMobileStep = 2;
            })
          }
        })
      }else {
        let data = {
          mobile: this.userInfo.mobile,
          code: this.mobile.code
        }
        this.reqValidateSMS(data).then((res) => {
          if(res) {
            this.currentMobileStep += 1;
          }
        })
      }
    },
    onBindMobile() {
      this.reinitTimer();
      this.mobile = {};
      this.newmobile = {};
      this.currentMobileStep = 0;
      this.isBindMobile = true;
    },
    onChangePage() {
      this.isBindMobile = false;
      this.isUpdatePassword = false;
      this.load();
    },
    dearFatherFun() {
      console.log('调用父组件')
      this.newUserid = JSON.parse(localStorage.userData).userid
      this.load();
      this.getWecharList()
      
    },
    load() {
      let params = {
        module: 'DEALER'
      }
      Promise.all([
        this.reqDealerInfo(),
        this.reqCustomField(params),
      ]).then(result => {
        let res = [];
        let fields = result[1].basic.data.concat(result[1].add.data);
        for(let i of fields) {
          for(let j in result[0].data) {
            if(i.fieldvalue === j && i.fieldvalue === "hlevelid" && result[0].data["hlevelname"]) {
              res.push({
                label: i.fieldname,
                value: result[0].data["hlevelname"]
              })
              continue;
            }
            if(i.fieldvalue === 'address') {
              res.push({
                label: i.fieldname,
                value: result[0].data["province"] + result[0].data["city"] + result[0].data["strict"] + " " + result[0].data["address"]
              })
              console.log(res)
              break;
            }
            if(i.fieldvalue === j && result[0].data[j] && i.isChecked === 1) {
              res.push({
                label: i.fieldname,
                value: result[0].data[j]
              })
            }
          }
        }
        this.customFields = res;
        this.reqMyInfomation();
      })
      this.reqUser();
      // this.reqMyInfomation();
    },
  },
  watch: {
    msgNum (newVal) {
      console.log(newVal)
      for (let a in newVal) {
        this.visibleShow.push(false)
      }
      console.log(this.visibleShow)
    }
  },
  computed: {
    hasMobile() {
      return this.userInfo.mobile ? true : false;
    },
    ...mapState({
      userInfo: state => state.myInfomation.userInfo,
      dealerInfo: state => state.myInfomation.dealerInfo,
      // myInfo: state => state.myInfomation.myInfo
    }),
    ...mapGetters(['wechatBindList']),
    msgNum: {
      get () {
        return this.wechatBindList
      }
    },
  },

  created() {
    this.newUserid = JSON.parse(localStorage.userData).userid
    this.getWecharList()
    this.load();
  },

  mounted() {},
}
</script>


<style lang='scss'>
@import "style/activityDeclaration.scss";
@import "style/myInfomation.scss";
.breadcrumb-box .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: bold;
}
#newDataInformation {
  .el-dialog__header {
    border-bottom: none;
  }
}
#newDealCard {
  .el-form-item {
    margin-bottom: 0px !important;
  }
  .el-card__body {
    padding: 0px !important;
  }
}

.breadcrumb-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #fff;
  padding-left: 20px;
}
</style>
